import React from 'react';
import Helmet from 'react-helmet';

import getConfig from '../../../../../../../util/config';
import { getAsset } from '../../../../../../../util/assets';

const AlbumFolderStartShutterbugHeadMeta = () => {
  const {
    app: { pageUrl },
  } = getConfig();

  return (
    <Helmet>
      <title>Get pics of your family texted to your phone!</title>
      <meta property="og:url" content={pageUrl} />
      <meta property="og:type" content="website" />
      <meta
        property="og:title"
        content="Get pics of your family texted to your phone!"
      />
      <meta
        property="og:description"
        content="Hi! I’m Waldo, your photo-finding phenom. Welcome to ad-free, non-toxic photo sharing!"
      />
      <meta
        property="og:image"
        content={getAsset('/og-link-preview-consumer.png')}
      />
    </Helmet>
  );
};

export default AlbumFolderStartShutterbugHeadMeta;
